/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IBetWayWinData, IBetWinData, IGameData, IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ITombOfAkhenatenInitData, ITombOfAkhenatenServerData} from "./data/ITombOfAkhenatenServerData";

export class TombOfAkhenatenServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    /**
     * @description: To create 25 reels individually from the response that we get of 5*5 matrix of reels.
     *
     * @param {array} rawReels 2d array of 5*5 reels.
     *
     * @returns: {array} 25 individual reels.
     */
    private static parseReelArrays(rawReels: string[][]): string[][] {
        let result: string[][] = [];

        for (let i: number = 0; i < rawReels.length; i++) {
            for (let j: number = 0; j < rawReels[i].length; j++) {
                result.push([rawReels[i][j]]);
            }
        }
        return result;
    }

    public parseStickySymbols(rawData: ITombOfAkhenatenServerData): string[][] {
        //BookOfShadowsGameConfig.instance.FS_SPECIAL_SYMBOL = (rawData.mode !== BookOfShadowsGameMode.NORMAL || (rawData as IBookOfShadowInitData).isRestoreState) ? rawData.fsSpecialSymbol : "";

        let result: string[][] = [];

        for (let i: number = 0; i < rawData.stickySymbols.length; i++) {
            for (let j: number = 0; j < rawData.stickySymbols[i].length; j++) {
                result.push([rawData.stickySymbols[i][j]]);
            }
        }
        return result;
    }

    public parseActiveRows(rawData:ITombOfAkhenatenServerData):number {
        return rawData.activeRows;
    }

    public parseActiveRowsNextSpin(rawData:ITombOfAkhenatenServerData):number {
        return rawData.activeRowsNextSpin;
    }

    public parsePayoutMultiplier(rawData: ITombOfAkhenatenServerData): number {
        return rawData.payoutMultiplier;
    }

    public parsePayoutMultiplierBefore(rawData: ITombOfAkhenatenServerData): number {
        return rawData.payoutMultiplierBefore;
    }

    public parseReels(rawData: IServerData): string[][] {
        return TombOfAkhenatenServerDataParser.parseReelArrays(rawData.reels);
    }

    public parsePayoutMultiplierNextSpin(rawData: ITombOfAkhenatenServerData): number {
        return rawData.payoutMultiplierNextSpin;
    }

    public parseNearWinPositions(rawData: ITombOfAkhenatenServerData): boolean[][] {
        return rawData.nearWinPositions;
    }

    public parseBetWinsOnInit(rawData: ITombOfAkhenatenInitData): IBetWayWinData[] | undefined {
        return rawData.betWayWins
    }

    public getExtraWildPosition(rawData: ITombOfAkhenatenServerData): number[] {
        return rawData.extraWildPosition;
    }

    public getEvaluatedArea(rawData: ITombOfAkhenatenServerData): string[][] {
        return rawData.evaluatedArea;
    }

    public getPyramidReelLand(rawData: ITombOfAkhenatenServerData): boolean[] {
        return rawData.pyramidReelLand;
    }

    public getFinalSpinWildPositions(rawData: ITombOfAkhenatenServerData): number[][] {
        return rawData.finalSpinWildPositions;
    }

    public getShowPyramidsReel(rawData: ITombOfAkhenatenServerData): boolean[] {
        return rawData.showPyramidsReel;
    }

    public parseBetWins(rawData:ITOAGameData):IBetWinData[] {
        if(rawData.betWayWinsUpdated && (rawData.betWayWinsUpdated.length > 0)){
            return rawData.betWayWinsUpdated;
        }else{
            return rawData.betWayWins || [];
        }
    }
}

interface ITOAGameData extends IGameData{
    betWayWinsUpdated?:IBetWayWinData[];
}